import { useState, useEffect } from "react";

export interface UseScrollPositionReturn {
  scrollY: number;
  isScrolled: boolean;
  showStickyNav: boolean;
}

export function useScrollPosition(threshold: number = 200): UseScrollPositionReturn {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    // Set initial value
    handleScroll();

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return {
    scrollY,
    isScrolled: scrollY > 0,
    showStickyNav: scrollY > threshold,
  };
}
